
import Vue from "vue";
import { mapState } from "vuex";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IRootState } from "@/store/types";
import { LOYALTY } from "@/store/loyalty";

export default Vue.extend({
  data() {
    return {
      loading: false,
      customerDetailsRouteName: LOYALTY_ROUTE_NAMES.CUSTOMER_DETAILS
    };
  },
  computed: {
    customerId() {
      return this.$route.params.id;
    },
    customerName() {
      return this.customer && this.customer.customerName;
    },
    ...mapState({
      customer: (state: IRootState) => state.loyalty.customer
    })
  },
  async mounted() {
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), true);

    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER),
      this.customerId
    );

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), false);
  }
});
